// BackingConfirmDialog — the ADR-052 companion-scope-grant confirm, shared by every
// level's ChainsDrawer (site · cluster · zone · team). When an
// assignment would leave a newly-added person unable to see the place they're
// answerable for, the save 409s ASSIGNEE_NOT_BACKED and this confirm offers to grant
// them the backing scope in the same transaction. At the TEAM level the backing is
// MEMBERSHIP (ADR-083 §3): the `membership` variant offers to add them to the team
// instead. Copy is single-homed in the `common` namespace (`accountability.backing.*`
// · `accountability.membership.*`), so no level can drift.

import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '../ui/ConfirmDialog.js';

export function BackingConfirmDialog({
  open,
  place,
  names,
  onConfirm,
  onClose,
  variant = 'scope',
}: {
  open: boolean;
  /** The scope target's display name (the zone / cluster / site the grant covers — or the team). */
  place: string;
  /** The unbacked assignees who would be granted scope — or added to the team. */
  names: string[];
  onConfirm: () => void;
  onClose: () => void;
  /** `scope` (the default) — the companion scope grant; `membership` — the team level's companion, the membership. */
  variant?: 'scope' | 'membership';
}) {
  const { t } = useTranslation('common');
  const k = variant === 'membership' ? 'accountability.membership' : 'accountability.backing';
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      tone="default"
      title={t(`${k}.title`, { place })}
      description={t(`${k}.body`, { names: names.join(', '), place })}
      confirmLabel={t(`${k}.confirm`)}
    />
  );
}
